import { useCallback } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import snb_logo from '../../assets/snb_logo.png';
import { Avatar } from '@react-md/avatar';
import { Card, CardContent, CardTitle, CardHeader, CardSubtitle } from '@react-md/card';

function PageNotFound() {
    const navigate = useNavigate();
    const home = useCallback(() => {
        navigate('/');
    }, [navigate]);

    return (
        <div className="Card-container">
            <div className="login-container-width main background notFoundPage background-primary">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12"></div>
                </div>

                <Card className="cardNotFound">
                    <CardHeader beforeChildren={<Avatar onClick={home} className="snb-Logo snbIconAnimatied" src={snb_logo} />}>
                        <CardTitle>Oops...!</CardTitle>
                        <CardSubtitle>Page Not Found</CardSubtitle>
                    </CardHeader>

                    <CardContent>
                        <p>The page you requested could not found</p>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(PageNotFound);
